import React, { useRef } from 'react'
import styled from 'styled-components'

import AddButton from 'components/AddButton'
import Spinner from 'components/Spinner'

import List from 'pages/Notifications/List'

import { useStoreContext } from 'hooks/StoreContext'
import useNotificationRecipients from 'hooks/useNotificationRecipients'
import useAutoFocus from 'hooks/useAutoFocus'

import { color } from 'styles/colors'
import { PageHeader, PageTitle, screenSize } from 'styles/shared'

const Notifications = () => {
  useNotificationRecipients()

  const {
    notificationRecipients,
    areNotificationRecipientsLoaded
  } = useStoreContext()

  const title = useRef(null)
  useAutoFocus({ isLoaded: areNotificationRecipientsLoaded, element: title })

  return (
    <S.Container>
      <S.PageHeader>
        <PageTitle ref={title}>Notifications</PageTitle>
      </S.PageHeader>

      <S.AddButton uri="/notifications/new" testId={'Add Recipient'}>Add Recipient</S.AddButton>

      <S.ListBackground>
        <S.List>
          {areNotificationRecipientsLoaded ? (
            <List notificationRecipients={notificationRecipients} />
          ) : (
            <Spinner variant="page" />
          )}
        </S.List>
      </S.ListBackground>
    </S.Container>
  )
}

export default Notifications

const S = {
  Container: styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
  `,
  PageHeader: styled(PageHeader)`
    margin-bottom: 20px;

    @media ${screenSize.small} {
      display: none;
    }
  `,
  AddButton: styled(AddButton)`
    align-self: flex-end;
    margin-right: 20px;
  `,
  ListBackground: styled.div`
    height: 100%;
    width: 100%;
    align-self: center;
    padding: 10px;
  `,
  List: styled.div`
    height: 100%;
    width: 100%;
    padding: 20px;
    background-color: ${color('paneBackground')};
  `
}
